import * as React from "react";
import { Grid, TextField, FormControlLabel, Checkbox } from "@material-ui/core";
import { IFieldErrors } from "../utils/ValidationUtils";

interface IProps {
  isOneMedical: boolean;
  onIsOneMedicalChange: (value: boolean) => void;
  prescriberOrderNumber: string;
  onPrescriberOrderNumberChange: (value: string) => void;
  fieldErrors: IFieldErrors;
}

const PRESCRIBER_ORDER_NUMBER_HELPER_TEXT =
  "Header.PrescriberOrderNumber. Must match the order number of the prescription prescribed at One Medical. ClinicName is set to 'One Medical'.";

/**
 * "One Medical prescription" checkbox plus the conditional Prescriber Order
 * Number field. When checked, the payload's ClinicName is forced to
 * "One Medical" and the order number must match the OM-prescribed order (it is
 * never auto-generated), so the field is required.
 *
 * Shared by the Upload NewRx to S3 and Unified NewRx Workflow sections.
 */
const OneMedicalPrescriptionField: React.FC<IProps> = ({
  isOneMedical,
  onIsOneMedicalChange,
  prescriberOrderNumber,
  onPrescriberOrderNumberChange,
  fieldErrors,
}) => {
  return (
    <>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              checked={isOneMedical}
              onChange={(e) => onIsOneMedicalChange(e.target.checked)}
              color="primary"
            />
          }
          label="One Medical prescription"
        />
      </Grid>

      {isOneMedical && (
        <Grid item xs={12}>
          <TextField
            required
            label="Prescriber Order Number"
            variant="filled"
            value={prescriberOrderNumber}
            onChange={(e) => onPrescriberOrderNumberChange(e.target.value)}
            fullWidth
            error={!!fieldErrors.prescriberOrderNumber}
            placeholder="om-e5eb97bffcb311c491883bae076e4f5e"
            helperText={
              fieldErrors.prescriberOrderNumber ||
              PRESCRIBER_ORDER_NUMBER_HELPER_TEXT
            }
          />
        </Grid>
      )}
    </>
  );
};

export default OneMedicalPrescriptionField;
